import useSidebarState from '../../hooks/useSidebarState';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Outreach.css';
import Sidebar from '../Sidebar';
import OutreachCampaigns from './OutreachCampaigns';
import OutreachDraft from './OutreachDraft'; // Will create next
import { useLanguage } from '../../contexts/LanguageContext';

const Outreach = () => {
    const [sidebarCollapsed, setSidebarCollapsed] = useSidebarState();
    const { t } = useTranslation('sourcing');
    const { isRTL } = useLanguage();

    // Navigation State
    // view: 'campaigns' | 'draft' | 'editor'
    const location = useLocation();
    const [currentView, setCurrentView] = useState(location.state?.view || 'campaigns');
    const [selectedCampaign, setSelectedCampaign] = useState(location.state?.campaign || null);

    // Only use location.state.tab if we are initializing into the draft view
    const [initialTabForDraft, setInitialTabForDraft] = useState(
        (location.state?.view === 'draft') ? location.state?.tab : null
    );

    const handleSelectCampaign = (campaign) => {
        setInitialTabForDraft(null); // Reset active tab when opening a new campaign from list
        setSelectedCampaign(campaign);
        setCurrentView('draft');
    };

    const handleBackToCampaigns = () => {
        setSelectedCampaign(null);
        setCurrentView('campaigns');
    };

    return (
        <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--app-background, #031128)' }}>
            <Sidebar collapsed={sidebarCollapsed} onToggle={setSidebarCollapsed} />

            <div
                className="outreach-container"
                style={{
                    marginInlineStart: sidebarCollapsed ? '60px' : '240px',
                    width: `calc(100vw - ${sidebarCollapsed ? '60px' : '240px'})`,
                    transition: 'margin-inline-start 250ms ease, width 250ms ease',
                }}
            >
                {/* Header - Only visible in Campaigns view */}
                {currentView === 'campaigns' && (
                    <div className="outreach-header" style={{ marginBottom: '40px' }}>
                        <h1>{t('outreach.title', 'Candidate Outreach Campaigns')}</h1>
                        <p>{t('outreach.subtitle', 'Automated, AI-powered outreach for all your Talent Search Engine shortlists.')}</p>
                    </div>
                )}

                {currentView === 'campaigns' && (
                    <OutreachCampaigns onSelectCampaign={handleSelectCampaign} />
                )}

                {currentView === 'draft' && (
                    <OutreachDraft
                        campaign={selectedCampaign}
                        onBack={handleBackToCampaigns}
                        initialTab={initialTabForDraft}
                    />
                )}
            </div>
        </div>
    );
};

export default Outreach;
